import { JetView } from 'webix-jet'; // Importing JetView from webix-jet framework
import GeoView from 'views/customers/geo'; // Importing GeoView component
import MoneyView from 'views/customers/money'; // Importing MoneyView component
import AgeView from 'views/customers/age'; // Importing AgeView component
import TagsView from 'views/customers/tags'; // Importing TagsView component
import PositionsView from 'views/customers/positions'; // Importing PositionsView component
import JugadoresActivosView from 'views/dashboard/jugadoresActivos'; // Importing JugadoresActivosView component
import JugadoresNuevosView from 'views/dashboard/jugadoresNuevos'; // Importing JugadoresNuevosView component
import DataView from 'views/dashboard/dataview'; // Importing DataView component
import { devConfig, profile, walletcode } from '../config/config'; // Importing configuration settings

/**
 * BettingVirtualView class extending JetView
 */
export default class BettingVirtualView extends JetView {
    /**
     * Configures the UI components for the view
     * @returns {Object} Configuration object for the view
     */
    config() {
        const _ = this.app.getService('locale')._; // Localization service
        var toDateLocal; // Variable for local end date
        var fromDateLocal; // Variable for local start date
        webix.ui.fullScreen(); // Set the UI to full screen mode
        return {
            css: 'bettingVirtual', // CSS class for styling
            scroll: true, // Enable scrolling
            responsive: true, // Enable responsive design
            rows: [
                // Define rows in the layout
                {
                    view: 'template', // Template view
                    template: "<div id='BIA_client_container'></div>", // HTML template
                    scroll: 'y', // Enable vertical scrolling
                },
            ],
        };
    }

    /**
     * Initializes the view and fetches necessary data
     */
    init() {
        var initThis = this; // Reference to the current instance
        var lng = 'es-ES'; // Default language set to Spanish
        if (this.app.getService('locale').getLang() == 'en') {
            // Check for English language
            lng = 'en'; // Set language to English
        } else {
            lng = 'es-ES'; // Default to Spanish
        }
        var skinIdITN; // Variable for skin ID
        if (
            profile.skinIdITN == undefined || // Check if skinIdITN is undefined
            profile.skinIdITN == undefined || // Duplicate check (likely a typo)
            profile.skinIdITN == null // Check if skinIdITN is null
        ) {
            skinIdITN = 'doradobet'; // Default skin ID
        } else {
            skinIdITN = profile.skinIdITN; // Use the defined skin ID
        }
        webix.ajax().get(devConfig.geturlApi() + 'Client/GetTokenBetting', '', {
            // AJAX request to get betting token
            error: function (text, data, XmlHttpRequest) {
                // Error callback
                webix.message('Error! '); // Display error message
            },
            success: function (text, data, XmlHttpRequest) {
                // Success callback
                var text = JSON.parse(text); // Parse the response text
                if (!text.HasError) {
                    // Check for errors in the response
                    var options = {
                        // Options for BetinactionAPI
                        token: text.data, // Token received from the API
                        skinid: skinIdITN, // Skin ID for the betting interface
                        walletcode: profile.walletcodeSportbookITN, // Wallet code from profile
                        full: true, // Full mode for the API
                        page: 'vfec', // Page identifier
                        lang: lng, // Language setting
                        fixed: false, // Fixed setting
                    };
                    var BIA = new BetinactionAPI( // Instantiate BetinactionAPI
                        '#BIA_client_container', // Target container for the API
                        options, // Options for the API
                    );
                } else {
                    webix.message('Error! '); // Display error message if API response indicates an error
                }
            },
        });
    }
}

// FILE DOCUMENTED
